/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const RelationshipType = {
    REFERRAL: 'REFERRAL',
    AFFILIATE: 'AFFILIATE'
} as const;
export type RelationshipType = typeof RelationshipType[keyof typeof RelationshipType];


export function instanceOfRelationshipType(value: any): boolean {
    for (const key in RelationshipType) {
        if (Object.prototype.hasOwnProperty.call(RelationshipType, key)) {
            if (RelationshipType[key as keyof typeof RelationshipType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function RelationshipTypeFromJSON(json: any): RelationshipType {
    return RelationshipTypeFromJSONTyped(json, false);
}

export function RelationshipTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): RelationshipType {
    return json as RelationshipType;
}

export function RelationshipTypeToJSON(value?: RelationshipType | null): any {
    return value as any;
}

export function RelationshipTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): RelationshipType {
    return value as RelationshipType;
}

